import React, { useState, useEffect } from "react";
import {
    makeStyles,
    useTheme,
    Paper,
    Grid,
    TextField,
    Table,
    Card,
    CardContent,
    Typography,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    IconButton,
    InputAdornment
} from "@material-ui/core";
import { Formik, Form, Field } from 'formik';
import ButtonWithSpinner from "../ButtonWithSpinner";
import ConfirmationModal from "../ConfirmationModal";
import ClearIcon from '@mui/icons-material/Clear';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import TitleIcon from '@mui/icons-material/Title';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import DescriptionIcon from '@mui/icons-material/Description';
import { Edit as EditIcon } from "@material-ui/icons";

import { toast } from "react-toastify";
import useHelps from "../../hooks/useHelps";
import { i18n } from "../../translate/i18n";


const useStyles = makeStyles(theme => ({
	root: {
		width: '100%'
	},
    mainPaper: {
		width: '100%',
		flex: 1,
		padding: theme.spacing(2)
    },
	fullWidth: {
		width: '100%'
	},
    tableContainer: {
		width: '100%',
		overflowX: "scroll",
		...theme.scrollbarStyles
    },
	textfield: {
		width: '100%'
	},
    textRight: {
        textAlign: 'right'
    },
    row: {
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(2)
    },
    control: {
		paddingRight: theme.spacing(1),
		paddingLeft: theme.spacing(1)
	},
    buttonContainer: {
        textAlign: 'right',
		padding: theme.spacing(1)
	}
}));

export function HelpManagerForm (props) {
    const { onSubmit, onDelete, onCancel, initialValue, loading } = props;
    const classes = useStyles();
    const theme = useTheme();

    const [record, setRecord] = useState(initialValue);

    useEffect(() => {
        setRecord(initialValue)
    }, [initialValue])

    const handleSubmit = async(data) => {
        onSubmit(data)
    }

    return (
        <Formik
            enableReinitialize
            className={classes.fullWidth}
            initialValues={record}
            onSubmit={(values, { resetForm }) =>
                setTimeout(() => {
                    handleSubmit(values)
                    resetForm()
                }, 500)
            }
        >
            {(values) => (
                <Form className={classes.fullWidth}>
                    <Grid spacing={2} justifyContent="flex-end" container>
                        <Grid item xs={12} sm={6} md={3}>
                            <Field
                                as={TextField}
                                label="Título"
                                name="title"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <TitleIcon color="primary" />
                                        </InputAdornment>
                                    ),
                                    style: { 
                                        backgroundColor: theme.palette.background.paper,
                                        borderRadius: "8px",
                                    }
                                }}
                                InputLabelProps={{ 
                                    style: { 
                                        fontWeight: "bold", 
                                        color: "#6517ab" 
                                    } 
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <Field
                                as={TextField}
                                label={i18n.t("helps.settings.codeVideo")}
                                name="video"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <VideoLabelIcon color="success" />
                                        </InputAdornment>
                                    ),
                                    style: { 
                                        backgroundColor: theme.palette.background.paper,
                                        borderRadius: "8px",
                                    }
                                }}
                                InputLabelProps={{ 
                                    style: { 
                                        fontWeight: "bold", 
                                        color: "#388e3c" 
                                    } 
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6}>
                            <Field
                                as={TextField}
                                label={i18n.t("helps.settings.description")}
                                name="description"
                                variant="outlined"
                                margin="dense"
                                fullWidth
                                multiline
                                rows={4}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <DescriptionIcon color="warning" />
                                        </InputAdornment>
                                    ),
                                    style: { 
                                        backgroundColor: theme.palette.background.paper,
                                        borderRadius: "8px",
                                    }
                                }}
                                InputLabelProps={{ 
                                    style: { 
                                        fontWeight: "bold", 
                                        color: "#f57c00" 
                                    } 
                                }}
                            />
                        </Grid>
                        <Grid sm={3} md={1} item>
                            <ButtonWithSpinner
                                startIcon={<ClearIcon />}
                                style={{
                                    color: "white",
                                    backgroundColor: "#6517ab",
                                    boxShadow: "none",
                                    borderRadius: "5px",
                                    fontSize: "12px",
                                }}
                                className={classes.fullWidth}
                                loading={loading}
                                onClick={() => onCancel()}
                                variant="contained">
                                {i18n.t("helps.settings.clear")}
                            </ButtonWithSpinner>
                        </Grid>
                        { record.id !== undefined ? (
                            <Grid sm={3} md={1} item>
                                <ButtonWithSpinner
                                    startIcon={<DeleteIcon />}
                                    className={classes.fullWidth}
                                    loading={loading}
                                    onClick={() => onDelete(record)}
                                    variant="contained"
                                    style={{
                                        color: "white",
                                        backgroundColor: "#db6565",
                                        boxShadow: "none",
                                        borderRadius: "5px",
                                        fontSize: "12px",
                                    }}
                                >
                                    {i18n.t("helps.settings.delete")}
                                </ButtonWithSpinner>
                            </Grid>
                        ) : null}
                        <Grid sm={3} md={1} item>
                            <ButtonWithSpinner
                                startIcon={<SaveIcon />}
                                className={classes.fullWidth}
                                loading={loading}
                                type="submit"
                                variant="contained"
                                style={{
                                    color: "white",
                                    backgroundColor: "#8E2DE2",
                                    boxShadow: "none",
                                    borderRadius: "5px",
                                    fontSize: "12px",
                                }}
                            >
                                {i18n.t("helps.settings.save")}
                            </ButtonWithSpinner>
                        </Grid>
                    </Grid>
                </Form>
            )}
        </Formik>
    )
}

export function HelpsManagerGrid (props) {
    const { records, onSelect } = props
    const classes = useStyles()
    const theme = useTheme()

    return (
        <Paper className={classes.tableContainer}>
            <Grid container spacing={3} style={{ padding: "16px" }}>
                {records.map((row) => (
                    <Grid item xs={12} sm={6} md={4} key={row.id}>
                        <Card
                            variant="outlined"
                            style={{
                                backgroundColor: theme.palette.background.paper,
                                border: `1px solid ${theme.palette.divider}`,
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                borderRadius: "10px",
                                padding: "20px",
                                margin: "10px",
                                transition: "transform 0.2s ease-in-out",
                                cursor: "pointer",
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                        >
                            <CardContent>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Typography variant="h6" style={{ fontWeight: "bold", color: "#6517ab" }}>
                                        <TitleIcon fontSize="small" style={{ verticalAlign: "middle", marginRight: 8 }} />
                                        {row.title || "-"}
                                    </Typography>
                                    <IconButton onClick={() => onSelect(row)} aria-label="edit" style={{ color: "#6517ab" }}>
                                        <EditIcon />
                                    </IconButton>
                                </div>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    style={{
                                        marginTop: "8px",
                                        marginBottom: "8px",
                                        fontSize: "0.875rem",
                                        color: theme.palette.text.secondary,
                                    }}
                                >
                                    <DescriptionIcon fontSize="small" style={{ verticalAlign: "middle", marginRight: 8, color: "#f57c00" }} />
                                    {i18n.t("helps.settings.description")}: {row.description || "-"}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    style={{
                                        marginBottom: "8px",
                                        fontSize: "0.875rem",
                                        fontWeight: "bold",
                                        color: "#388e3c",
                                    }}
                                >
                                    <VideoLabelIcon fontSize="small" style={{ verticalAlign: "middle", marginRight: 8 }} />
                                    Vídeo: {row.video || "-"}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    )
}

export default function HelpsManager () {
    const classes = useStyles()
    const theme = useTheme();
    const { list, save, update, remove } = useHelps()
    
    const [showConfirmDialog, setShowConfirmDialog] = useState(false)
    const [loading, setLoading] = useState(false)
    const [records, setRecords] = useState([])
    const [record, setRecord] = useState({
        title: '',
        description: '',
        video: ''
    })

    useEffect(() => {
        async function fetchData () {
            await loadHelps()
        }
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const loadHelps = async () => {
        setLoading(true)
        try {
            const helpList = await list()
            setRecords(helpList)
        } catch (e) {
            toast.error('Não foi possível carregar a lista de registros')
        }
        setLoading(false)
    }

    const handleSubmit = async (data) => {
        setLoading(true)
        try {
            if (data.id !== undefined) {
                await update(data)
            } else {
                await save(data)
            }
            await loadHelps()
            handleCancel()
            toast.success('Operação realizada com sucesso!')
        } catch (e) {
            toast.error('Não foi possível realizar a operação. Verifique se já existe uma helpo com o mesmo nome ou se os campos foram preenchidos corretamente')
        }
        setLoading(false)
    }

    const handleDelete = async () => {
        setLoading(true)
        try {
            await remove(record.id)
            await loadHelps()
            handleCancel()
            toast.success('Operação realizada com sucesso!')
        } catch (e) {
            toast.error('Não foi possível realizar a operação')
        }
        setLoading(false)
    }

    const handleOpenDeleteDialog = () => {
        setShowConfirmDialog(true)
    }

    const handleCancel = () => {
        setRecord({
            title: '',
            description: '',
            video: ''
        })
    }

    const handleSelect = (data) => {
        setRecord({
            id: data.id,
            title: data.title || '',
            description: data.description || '',
            video: data.video || ''
        })
    }

    return (
        <Paper className={classes.mainPaper} elevation={0}>
            <Grid spacing={2} container>
                <Grid xs={12} item>
                    <HelpManagerForm 
                        initialValue={record} 
                        onDelete={handleOpenDeleteDialog} 
                        onSubmit={handleSubmit} 
                        onCancel={handleCancel} 
                        loading={loading}
                    />
                </Grid>
                <Grid xs={12} item>
                    <HelpsManagerGrid 
                        records={records}
                        onSelect={handleSelect}
                    />
                </Grid>
            </Grid>
            <ConfirmationModal
                title="Exclusão de Registro"
                open={showConfirmDialog}
                onClose={() => setShowConfirmDialog(false)}
                onConfirm={() => handleDelete()}
            >
                Deseja realmente excluir esse registro?
            </ConfirmationModal>
        </Paper>
    )
}